import { FunctionComponent as F } from "react";
import { useSelector } from 'react-redux';
import { Box, Typography, Stack } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { IState } from "../../core/store/store";
import { composeDeliveryBreakdown, composeTaxBreakdown } from "../../utils/string";
import TextTooltipOpt from "../UI/Tooltip/TextTooltipOpt";
import TextTooltip from "../UI/Tooltip/TextTooltip";
import UpdateTax from "../UI/Button/UpdateTax";
import { useParams } from "react-router-dom";


interface Props
{
  listingId: number;
}

interface Params
{
  protocolId?: string
}


const PriceWithTaxPlusDelivery: F<Props> = (props: Props) =>
{
  const params = useParams() as Params;

  const listing = useSelector((state: IState) => state.listings.listings
    ?.find(l => l.listingId === props.listingId));
  const priceWithFees = useSelector((state: IState) => state.listings.listings
    ?.find(l => l.listingId === props.listingId)?.priceWithFees);
  const userCurrencySymbol = useSelector((state: IState) => state.user.currencySymbol);
  const protocolCurrencySymbol = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.currencySymbol);
  const protocolCurrencyCode = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.currencyCode);

  if(!listing)
    return <></>;

  const exchangeRateText =
    (listing?.exchangeRate && listing?.exchangeRate !== 1) ?
      "@" +
        listing.listingCurrencyCode + "->" +
        protocolCurrencyCode + " " + (listing.exchangeRate).toFixed(3) :
      "";

  const tooltipText = [
    exchangeRateText,
    composeTaxBreakdown(listing, userCurrencySymbol),
    composeDeliveryBreakdown(listing)]
    .filter(t => t) as string[];

  const priceString = (priceWithFees || priceWithFees === 0) ? protocolCurrencySymbol + " " +
    ((priceWithFees || 0) + (listing.deliveryPrice || 0) * listing.exchangeRate)?.toFixed(2) : "-";

  return(
    <Stack direction='row' spacing={1}>

      <TextTooltipOpt
        showtooltip={Boolean(listing?.exchangeRate !== 1 || listing.baseTax || listing.taxPercent)}
        children={<Typography variant='body2'>{priceString}</Typography>}
        lines={tooltipText}/>

      <Box sx={{ pt: 0.15 }}>
        <UpdateTax listing={listing} vendorId={listing.vendorId}/>
      </Box>

      <TextTooltip lines={[(listing.deliveryPrice === 0 && !listing.deliveryPriceEstimated) ?
        "Potential free delivery" :
        "Delivery charges may apply"]}>
        <LocalShippingIcon
          fontSize='small'
          sx={{ height: '200', color: listing.deliveryPrice === 0 ? 'green' : 'lightGray' }}/>
      </TextTooltip>

    </Stack>);
};

export default PriceWithTaxPlusDelivery;
